module.exports = __webpack_public_path__ + "static/media/saved-doc.307d5c25.svg";